<script lang="ts">
    export let percentageValue: number;
    export let showPercentage = true;

    $: percentageFormattedText = formatAsPercentage(percentageValue);
    $: progressBarClass = resolveProgressBarColorClass(percentageValue);

    const percentageFormatter = new Intl.NumberFormat('default', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });

    function formatAsPercentage(num: number): string {
        return percentageFormatter.format(num);
    }

    function resolveProgressBarColorClass(num: number) {
        if (num <= 0.25) {
            return 'progress-red';
        }
        if (num <= 0.5) {
            return 'progress-orange';
        }
        if (num <= 0.75) {
            return 'progress-yellow';
        }
        return 'progress-green';
    }
</script>

<div class="progress-container">
    <progress value={percentageValue} class={progressBarClass}>{percentageFormattedText}</progress>

    {#if showPercentage}
        <span class="progress-value-text">{percentageFormattedText}</span>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";

    @red: #ef5a66;
    @orange: #ffb74a;
    @yellow: #fff05f;
    @green: #74d281;
    @light-grey: #f3f3f3;
    @progress-bar-text: #000;
    @progress-bar-border-radius: 4px;

    .progress-container {
        position: relative;
        width: 100%;
        height: 20px;
        background-color: @light-grey;
        border-radius: @progress-bar-border-radius;
        outline: 1px solid @themed-border-default;
        outline-offset: -1px;
    }

    progress {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;

        width: 100%;
        height: 100%;
        min-width: 2em;
        border-radius: @progress-bar-border-radius;

        &.progress-red {
            --progress-bar-color: @red;
        }

        &.progress-orange {
            --progress-bar-color: @orange;
        }

        &.progress-yellow {
            --progress-bar-color: @yellow;
        }

        &.progress-green {
            --progress-bar-color: @green;
        }

        &::-webkit-progress-bar {
            background-color: transparent;
        }

        &::-webkit-progress-value {
            border-radius: @progress-bar-border-radius;
            background-color: var(--progress-bar-color);
        }

        &::-moz-progress-bar {
            border-radius: @progress-bar-border-radius;
            background-color: var(--progress-bar-color);
        }
    }

    .progress-value-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: @progress-bar-text;
        font-weight: bold;
    }
</style>